import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    available: 'Available',
    selected: 'Selected',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    expand: 'Expand item',
    collapse: 'Collapse item',
    noData: 'No available items',
    select: 'Please select',
    remove: 'Remove item'
  },
  {
    ns: 'transfer'
  }
)
